import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Injectable()
export class AppMonitoringService {
	appInsights: ApplicationInsights;
	constructor(private router: Router) {
		this.appInsights = new ApplicationInsights({
			config: {
				instrumentationKey: environment.appInsights.instrumentationKey,
				enableAutoRouteTracking: true
			}
		});
		this.appInsights.loadAppInsights();
		this.trackRouterChange();
	}

	trackRouterChange() {
		this.router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				const url = event.urlAfterRedirects || event.url;
				const pageName = url.substring(1); // Modify as per your route structure

				//this.logPageView(pageName,url);
			}
		});
	}

	setUserId(userId: string) {
		this.appInsights.setAuthenticatedUserContext(userId);
	}
	clearUserId() {
		this.appInsights.clearAuthenticatedUserContext();
	}
	logPageView(name?: string, uri?: string) {
		this.appInsights.trackPageView({
			name: name,
			uri: uri
		});
	}
	logPageView1(name: string, average: number, properties?: { [key: string]: any }) {
		this.appInsights.trackPageView({
			name: "My Page View",
			properties: {
				ServiceName: "My Service"
			}
		});
	}
	logEvent(name: string, properties?: { [key: string]: any }) {
		this.appInsights.trackEvent({ name: name }, properties);

	}
	logMetric(name: string, average: number, properties?: { [key: string]: any }) {
		this.appInsights.trackMetric({ name: name, average: average }, properties);

	}
	logException(exception: Error, severityLevel?: number) {
		this.appInsights.trackException({ exception: exception, severityLevel: severityLevel });
	}

	logTrace(message: string, properties?: { [key: string]: any }) {
		this.appInsights.trackTrace({ message: message }, properties);
	}
}